import { defineComponent, computed } from "vue";
import { useRoomStore } from "../../../../stores/room.mjs";
import Avatar from "../../../common/Avatar.vue.mjs";
import AudioIcon from "../../../common/AudioIcon.vue.mjs";
import SvgIcon from "../../../common/base/SvgIcon.vue.mjs";
import UserIcon from "../../../common/icons/UserIcon.vue.mjs";
import { useI18n } from "../../../../locales/index.mjs";
import { TUIVideoStreamType, TUIRole } from "@tencentcloud/tuiroom-engine-js";
import { isInnerScene } from "../../../../utils/constants.mjs";
import ScreenOpenIcon from "../../../common/icons/ScreenOpenIcon.vue.mjs";
import { isPC, isMobile } from "../../../../utils/environment.mjs";
import { storeToRefs } from "pinia";
import LoadingIcon from "../../../common/icons/LoadingIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    streamInfo: null,
    enlargeDomId: null,
    changeLargeStream: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const roomStore = useRoomStore();
    const { t } = useI18n();
    const { userVolumeObj } = storeToRefs(roomStore);
    const userInfo = computed(() => roomStore.userInfoObj[props.streamInfo.userId]);
    const displayName = computed(() => {
      if (isInnerScene) {
        return `${roomStore.getDisplayName(props.streamInfo.userId)} | ${props.streamInfo.userId}`;
      }
      return roomStore.getDisplayName(props.streamInfo.userId);
    });
    const showMasterIcon = computed(() => {
      const { userId, streamType } = props.streamInfo;
      return userId === roomStore.masterUserId && streamType === TUIVideoStreamType.kCameraStream;
    });
    const showAdminIcon = computed(() => {
      const { userId, streamType } = props.streamInfo;
      return roomStore.getUserRole(userId) === TUIRole.kAdministrator && streamType === TUIVideoStreamType.kCameraStream;
    });
    const showVoiceBorder = computed(() => {
      if (isPC) {
        return false;
      }
      return props.streamInfo.hasAudioStream && userVolumeObj.value[props.streamInfo.userId] !== 0;
    });
    const showIcon = computed(() => showMasterIcon.value || showAdminIcon.value);
    const isScreenStream = computed(
      () => props.streamInfo.streamType === TUIVideoStreamType.kScreenStream
    );
    return { __sfc: true, roomStore, t, props, userVolumeObj, userInfo, displayName, showMasterIcon, showAdminIcon, showVoiceBorder, showIcon, isScreenStream, Avatar, AudioIcon, SvgIcon, UserIcon, ScreenOpenIcon, isPC, isMobile, LoadingIcon };
  }
});
export {
  _sfc_main as default
};
